'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ramda = require('ramda');

var _common = require('./common');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var createAction = function createAction(t, action) {
  var type = (0, _common.toSet)(t);
  return [type, function (payload, params) {
    return {
      type: type,
      path: (0, _common.parsePath)(action.path, t),
      payload: (0, _ramda.isNil)(payload) ? null : payload,
      params: params
    };
  }];
};

var createHttpActions = function createHttpActions(t, action) {
  var types = (0, _common.toHttpMethods)(t, action);

  var fn = function fn(type) {
    return function (body, params) {
      if (!params && !(0, _common.hasBody)(type[0])) {
        params = body;
        body = null;
      }

      return {
        type: type[1],
        url: (0, _common.replace)(action.url, params),
        path: (0, _common.parsePath)(action.path, t, type[0]),
        params: params,
        body: body && (action.body ? action.body(body) : body)
      };
    };
  };

  return types.map(function (type) {
    return [type[1], fn(type)];
  });
};

exports.default = function (l) {
  l = (0, _common.attachDefault)(l);
  return (0, _ramda.fromPairs)((0, _ramda.reduce)(function (p, c) {
    var a1 = createAction(c, l[c]);
    return l[c].url ? [].concat(_toConsumableArray(p), _toConsumableArray(createHttpActions(c, l[c])), [a1]) : [].concat(_toConsumableArray(p), [a1]);
  }, [], Object.keys(l)));
};


//////////////////
// WEBPACK FOOTER
// ../dist/actions.js
// module id = 384
// module chunks = 0